import { useHttpClient } from './httpClient.js';

const resource = 'results';

export function updateResults(date, results) {
	return useHttpClient().put(`/${resource}`, {
		resultForm: {
			date,
			results
		}
	});
}

export function fetchResults(date) {
	return useHttpClient().get(`/${resource}`, { params: { date } });
}

export function destroyResult(date, sortitionId) {
	return useHttpClient().delete(`/${resource}/${sortitionId}/${date}`);
}
